module.exports = __webpack_public_path__ + "img/linkIconGray.b8d966ec.svg";